import type { CollateralType, EffectiveTradeStatus, FrameworkAgreement, TermType, TradeType } from '@/types';
import { TERMINAL_TRADE_STATUSES } from '@/types';
import { mockTradeBlotterData } from '@/test/fixtures/trades-fixtures';

const getUniqueValues = <T, U>(items: T[], getter: (item: T) => U): U[] =>
  Array.from(new Set(items.map(getter))).sort();

// LR-497: full settlement-status set in lifecycle order, including the two
// derived buckets (partially_settled / pending_partial_settlement). Human labels
// come from TRADE_STATUS_LABELS via the sidebar's optionLabels arg.
export const TRADE_STATUS_OPTIONS: EffectiveTradeStatus[] = [
  'pending',
  'pending_open_settlement',
  'partially_settled',
  'active',
  'pending_partial_settlement',
  'matured',
  'closed',
  'cancelled',
  'rejected',
];

// LR-497 / LR-376: the status filter is mode-aware. The All Trades blotter hides
// terminal positions (they live in the History tab), so offering Closed/Cancelled
// there is a dead option — All Trades shows only the non-terminal set; History
// shows only the terminal set. Both derive from TRADE_STATUS_OPTIONS so order and
// membership stay in lock-step with the full list above.
export const NON_TERMINAL_TRADE_STATUS_OPTIONS: EffectiveTradeStatus[] = TRADE_STATUS_OPTIONS.filter(
  (s) => !(TERMINAL_TRADE_STATUSES as readonly string[]).includes(s),
);

export const TERMINAL_TRADE_STATUS_OPTIONS: EffectiveTradeStatus[] = TRADE_STATUS_OPTIONS.filter(
  (s) => (TERMINAL_TRADE_STATUSES as readonly string[]).includes(s),
);

export const TRADE_TYPE_OPTIONS: TradeType[] = [
  'lend',
  'borrow',
  'repo',
  'reverse_repo',
];

export const TRADE_COLLATERAL_TYPE_OPTIONS: CollateralType[] = [
  'cash',
  'non_cash',
  'uncollateralized',
];

export const TRADE_AGREEMENT_TYPE_OPTIONS: FrameworkAgreement[] = ['gmsla', 'gmra'];

export const TRADE_TERM_TYPE_OPTIONS: TermType[] = ['open', 'evergreen', 'term'];

export const TRADE_CURRENCY_OPTIONS: string[] = getUniqueValues(
  mockTradeBlotterData,
  (t) => t.currency
);
